let ProgramUtil = {

  info: function (program, programStartTs, tz) {
    let currentDay = 0;
    let totalDays = 0;
    let schedules = [];
    let status = null;

    if (program) {
      let now = Date.now();
      let then = programStartTs ? mc.tz.info(programStartTs, tz, "DAY_START").value : now;

      currentDay = Math.ceil((now - then) / mc.math.MILLIS_PER_DAY);

      program.schedules.forEach(function (sched, i) {
        schedules.push({
          startDay: totalDays,
          displayName: sched.displayName,
          durationDays: sched.durationDays
        });

        totalDays += sched.durationDays;
      });

      if (!programStartTs) {
        status = "PENDING";
      }
      else if (currentDay > totalDays) {
        status = "COMPLETE";
      }
      else if (currentDay > 0) {
        status = "IN_PROGRESS";
      }
    }

    return {
      currentDay,
      totalDays,
      schedules,
      status
    };
  }
  
};

module.exports = ProgramUtil;